module.exports = __webpack_public_path__ + "static/JenniferRing-bcc18ed6935289e1acb79787595fcfa7.jpeg";